module.exports = __webpack_public_path__ + "static/assets/76cd1038baa3bca0d71a60cd1020438e.png";